
/**
 * QFDAPIService.js contains a central service for connecting with the QFD API.
 * It depends on axios and axios-retry.
 *
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */
// import * as retry from 'axios-retry';
import * as axios from 'axios';
import store from '@/store';



const headerConfigs = (config) => { 
    config.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': store.getters.getLoggedInUserIdToken
    };
    return config;
}

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API,
    withCredentials: false, // This is the default
    timeout: 30000,
});

apiClient.interceptors.request.use(headerConfigs);

const apiAuthClient = axios.create({
    baseURL: process.env.VUE_APP_AUTH_API,
    withCredentials: false, // This is the default
    timeout: 15000,
});
apiAuthClient.interceptors.request.use(headerConfigs);

var apiQFDClient = axios.create({
    baseURL: process.env.VUE_APP_QFD_API,
    withCredentials: false, // This is the default
    timeout: 15000,
});

apiQFDClient.interceptors.request.use(headerConfigs);

/*
retry(apiClient, {
    retries: 3,
    retryDelay: retry.exponentialDelay
});*/

export default {
    name: 'call',
    /**
     * Call the API
     * @param {String} url - the URL of the specific endpoint to call
     * @param {Object} params
     * @param {String} params.method - HTTP method to use for call
     * @param {String} api optional, pass QFD or Auth to call other apis, default is private api
     * @returns a promise with the API payload
     */
    async call(url, { method = 'post', ...otherParams } = {}, api) {
         // check if auth token expired
         if (!store.getters.getLoggedInUserIdToken || store.getters.getAccessTokenExpiration - Date.now() < 0) {
            console.error("No valid token found! Logging out");
            store.dispatch('logout');
            return;
        }
        const id = Math.floor(Math.random() * 10000);
        store.dispatch("addPendingCall", { id, url });
        let theClient;
        switch (api) {
            case "Auth":
                theClient = apiAuthClient;
                break;
            case "QFD":
                if (store.getters.getActiveTenant.engineURL === process.env.VUE_APP_QFD_API) {
                    theClient = apiQFDClient;
                } else {
                    theClient = axios.create({
                        baseURL: store.getters.getActiveTenant.engineURL,
                        withCredentials: false, // This is the default
                        timeout: 15000,
                    });
                    theClient.interceptors.request.use(headerConfigs);
                }
                break;
            default:
                theClient = apiClient;
        }
        return theClient.request({
            method,
            url,
            data: otherParams
        }).then((response) => {
            // Global handling for after API call success

            return response;
        }).catch(error => {
            // Global error handling done here

            throw (error);
        }).finally(() => {
            // Global handling for after API call completion
            store.dispatch("removePendingCall", id);
        });
    },
};